import React, { useState } from 'react';
import { NetworkIcon, Loader2Icon, SparklesIcon, ArrowRightIcon, MousePointerClickIcon, CreditCardIcon, MailIcon, ShoppingCartIcon } from 'lucide-react';
export function FunnelArchitect() {
  const [isGenerating, setIsGenerating] = useState(false);
  const [hasGenerated, setHasGenerated] = useState(false);
  const handleGenerate = () => {
    setIsGenerating(true);
    setTimeout(() => {
      setIsGenerating(false);
      setHasGenerated(true);
    }, 2500);
  };
  return <div className="max-w-6xl mx-auto space-y-8 animate-in fade-in duration-500" data-id="element-397">
      <div data-id="element-398">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-399">
          Arquitecto de Funnel
        </h1>
        <p className="text-slate-500 mt-1" data-id="element-400">
          Diseña la estrategia completa de tu embudo de ventas y genera el copy
          para cada etapa.
        </p>
      </div>

      <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200" data-id="element-401">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-402">
          <div className="space-y-2" data-id="element-403">
            <label className="block text-sm font-medium text-slate-700" data-id="element-404">
              Producto Principal (Front-end)
            </label>
            <input type="text" placeholder="Ej: Guía de Postres" className="w-full p-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" defaultValue="Guía Método Porción-Rentable" data-id="element-405" />
          </div>
          <div className="space-y-2" data-id="element-406">
            <label className="block text-sm font-medium text-slate-700" data-id="element-407">
              Precio ($)
            </label>
            <input type="text" placeholder="Ej: 27" className="w-full p-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" defaultValue="17" data-id="element-408" />
          </div>
          <div className="space-y-2" data-id="element-409">
            <label className="block text-sm font-medium text-slate-700" data-id="element-410">
              Objetivo
            </label>
            <select className="w-full p-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white" data-id="element-411">
              <option data-id="element-412">Adquisición de Clientes (SLO)</option>
              <option data-id="element-413">Maximizar AOV (Ticket Promedio)</option>
              <option data-id="element-414">Generación de Leads (Freebie)</option>
            </select>
          </div>
          <div className="space-y-2" data-id="element-415">
            <label className="block text-sm font-medium text-slate-700" data-id="element-416">
              Plataforma
            </label>
            <select className="w-full p-2.5 border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 bg-white" data-id="element-417">
              <option data-id="element-418">Hotmart</option>
              <option data-id="element-419">Systeme.io</option>
              <option data-id="element-420">Shopify</option>
              <option data-id="element-421">ThriveCart</option>
            </select>
          </div>
        </div>

        <div className="mt-8 flex justify-end pt-6 border-t border-slate-100" data-id="element-422">
          <button onClick={handleGenerate} disabled={isGenerating} className="bg-indigo-600 hover:bg-indigo-700 text-white px-8 py-3 rounded-xl font-medium flex items-center gap-2 disabled:opacity-50 transition-colors" data-id="element-423">
            {isGenerating ? <>
                <Loader2Icon className="w-5 h-5 animate-spin" data-id="element-424" /> Mapeando
                Funnel...
              </> : <>
                <SparklesIcon className="w-5 h-5" data-id="element-425" /> Diseñar Funnel Completo
              </>}
          </button>
        </div>
      </div>

      {hasGenerated && <div className="space-y-8 animate-in slide-in-from-bottom-4 duration-500" data-id="element-426">
          <h2 className="text-xl font-bold text-slate-900" data-id="element-427">
            Mapa del Funnel: Adquisición SLO (Self-Liquidating Offer)
          </h2>

          <div className="flex flex-col md:flex-row items-center justify-between gap-4 overflow-x-auto pb-4" data-id="element-428">
            {/* Stage 1 */}
            <div className="flex-shrink-0 w-64 bg-white p-5 rounded-xl border-2 border-blue-200 shadow-sm relative" data-id="element-429">
              <div className="absolute -top-3 -right-3 bg-blue-100 text-blue-700 p-1.5 rounded-lg" data-id="element-430">
                <MousePointerClickIcon className="w-4 h-4" data-id="element-431" />
              </div>
              <span className="text-xs font-bold text-blue-600 uppercase tracking-wider" data-id="element-432">
                1. Tráfico
              </span>
              <h3 className="font-bold text-slate-900 mt-1" data-id="element-433">
                Meta Ads (Video)
              </h3>
              <p className="text-xs text-slate-500 mt-2" data-id="element-434">
                Hook: "El error #1 al cobrar postres"
              </p>
              <button className="mt-4 w-full text-xs font-medium text-blue-600 bg-blue-50 py-1.5 rounded hover:bg-blue-100 transition-colors" data-id="element-435">
                Ver Copy
              </button>
            </div>

            <ArrowRightIcon className="w-6 h-6 text-slate-300 hidden md:block flex-shrink-0" data-id="element-436" />

            {/* Stage 2 */}
            <div className="flex-shrink-0 w-64 bg-white p-5 rounded-xl border-2 border-indigo-200 shadow-sm relative" data-id="element-437">
              <div className="absolute -top-3 -right-3 bg-indigo-100 text-indigo-700 p-1.5 rounded-lg" data-id="element-438">
                <NetworkIcon className="w-4 h-4" data-id="element-439" />
              </div>
              <span className="text-xs font-bold text-indigo-600 uppercase tracking-wider" data-id="element-440">
                2. Sales Page
              </span>
              <h3 className="font-bold text-slate-900 mt-1" data-id="element-441">
                Landing Larga (PAS)
              </h3>
              <p className="text-xs text-slate-500 mt-2" data-id="element-442">Precio: $17.00</p>
              <button className="mt-4 w-full text-xs font-medium text-indigo-600 bg-indigo-50 py-1.5 rounded hover:bg-indigo-100 transition-colors" data-id="element-443">
                Ver Copy
              </button>
            </div>

            <ArrowRightIcon className="w-6 h-6 text-slate-300 hidden md:block flex-shrink-0" data-id="element-444" />

            {/* Stage 3 */}
            <div className="flex-shrink-0 w-64 bg-white p-5 rounded-xl border-2 border-amber-200 shadow-sm relative" data-id="element-445">
              <div className="absolute -top-3 -right-3 bg-amber-100 text-amber-700 p-1.5 rounded-lg" data-id="element-446">
                <ShoppingCartIcon className="w-4 h-4" data-id="element-447" />
              </div>
              <span className="text-xs font-bold text-amber-600 uppercase tracking-wider" data-id="element-448">
                3. Checkout + Bump
              </span>
              <h3 className="font-bold text-slate-900 mt-1" data-id="element-449">Order Bump</h3>
              <p className="text-xs text-slate-500 mt-2" data-id="element-450">
                Pack 50 Recetas Rentables (+$9)
              </p>
              <button className="mt-4 w-full text-xs font-medium text-amber-600 bg-amber-50 py-1.5 rounded hover:bg-amber-100 transition-colors" data-id="element-451">
                Ver Copy
              </button>
            </div>

            <ArrowRightIcon className="w-6 h-6 text-slate-300 hidden md:block flex-shrink-0" data-id="element-452" />

            {/* Stage 4 */}
            <div className="flex-shrink-0 w-64 bg-white p-5 rounded-xl border-2 border-emerald-200 shadow-sm relative" data-id="element-453">
              <div className="absolute -top-3 -right-3 bg-emerald-100 text-emerald-700 p-1.5 rounded-lg" data-id="element-454">
                <CreditCardIcon className="w-4 h-4" data-id="element-455" />
              </div>
              <span className="text-xs font-bold text-emerald-600 uppercase tracking-wider" data-id="element-456">
                4. One-Click Upsell
              </span>
              <h3 className="font-bold text-slate-900 mt-1" data-id="element-457">
                Calculadoras Excel
              </h3>
              <p className="text-xs text-slate-500 mt-2" data-id="element-458">
                Precio: $27.00 (Toma rate est. 15%)
              </p>
              <button className="mt-4 w-full text-xs font-medium text-emerald-600 bg-emerald-50 py-1.5 rounded hover:bg-emerald-100 transition-colors" data-id="element-459">
                Ver Copy
              </button>
            </div>
          </div>

          <div className="bg-slate-900 text-white p-6 rounded-xl flex items-center justify-between" data-id="element-460">
            <div data-id="element-461">
              <h3 className="font-bold text-lg" data-id="element-462">
                Proyección Financiera (Estimada)
              </h3>
              <p className="text-slate-400 text-sm mt-1" data-id="element-463">
                Basado en benchmarks de Hotmart para el nicho Gastronomía
              </p>
            </div>
            <div className="text-right" data-id="element-464">
              <p className="text-sm text-slate-400" data-id="element-465">
                Ticket Promedio Esperado (AOV)
              </p>
              <p className="text-3xl font-black text-green-400" data-id="element-466">$22.40</p>
            </div>
          </div>
        </div>}
    </div>;
}